import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { MaterialModule } from '@core/material/material.module';

import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { GroupByPipe } from '@shared/pipes/group-by.pipe';
import { TruncateTextPipe } from '@shared/pipes/truncate-text.pipe';
import { RemoveUnderscorePipe } from '@shared/pipes/remove-underscore.pipe';
import { LazyLoadImageDirective } from '@shared/directives/lazy-load-image.directive';
import { LengthConverterPipe } from './pipes/length-converter.pipe';
import { RestartProgressDialogComponent } from './components/restart-progress-dialog/restart-progress-dialog.component';


@NgModule({
  declarations: [
    GroupByPipe,
    RemoveUnderscorePipe,
    SideNavbarComponent,
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    TruncateTextPipe,
    LazyLoadImageDirective,
    LengthConverterPipe,
    RestartProgressDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule
  ],
  exports: [
    GroupByPipe,
    LengthConverterPipe,
    TruncateTextPipe,
    RemoveUnderscorePipe,
    LazyLoadImageDirective,
    LoaderComponent,
    SideNavbarComponent,
    HeaderComponent,
    FooterComponent
  ],
  entryComponents: [
    RestartProgressDialogComponent
  ]
})
export class SharedModule { }
